export const defaultFields = ["description", "internal_description", "checklist_type_id"];

export function typeDefaults(type) {
  return {
    description: type?.default_description || "",
    internal_description: type?.default_internal_description || "",
    checklist_type_id: type?.checklist ? type.default_checklist_type_id || null : null,
  };
}

// Ownership matters: a deliberate edit/clear is never overwritten on type changes.
export function applyTypeDefaults(values, type, owned = {}, enabled = true) {
  const defaults = typeDefaults(type);
  const next = { ...values };
  defaultFields.forEach((field) => { if (!owned[field]) next[field] = enabled ? defaults[field] : field === "checklist_type_id" ? null : ""; });
  return next;
}

export function initialReportValues(props) {
  const draft = props.selected || {};
  const fields = props.fields || {};
  const customer = draft.customer || props.customer;
  const project = draft.project || props.project;
  const now = new Date();
  const localDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  return {
    customer_id: customer?.id || null, project_id: project?.id || null,
    contact_id: draft.contact?.id || props.contact?.id || null,
    report_type: draft.report_type?.id || props.report_type?.id || null,
    order_date: draft.order_date || localDate,
    description: draft.description ?? fields.description ?? "",
    internal_description: draft.internal_description ?? fields.internal_description ?? "",
    checklist_type_id: draft.checklist_type_id || draft.checklist?.checklist_type?.id || null,
    system_id: draft.system?.id || null, folder_id: draft.folder?.id || null,
    delivery_address_id: draft.delivery_address?.id || props.delivery_address?.id || null,
    useCustomerAddress: Boolean(draft.useCustomerAddress),
    invoice_customer_id: draft.invoice_customer?.id || null,
    other_invoice_customer: Boolean(draft.invoice_customer?.id),
    invoice_to_project_customer: Boolean(draft.invoice_to_project_customer),
    cost_included_in_project: Boolean(draft.cost_included_in_project),
    sales_income_included_in_project: Boolean(draft.sales_income_included_in_project),
    do_not_expect_income: Boolean(draft.do_not_expect_income),
    sequel_main_report_id: draft.sequel_main_report_id || draft.sequelMainReport?.id || null,
  };
}
